// extracted by mini-css-extract-plugin
export default {"settingPanelHeightToAuto":"aill9NzsUhFl6g37CI3R","shadowOnScroll":"UvMGbdoBJV5S5uSWlLHZ"};